import { ChangeDetectionStrategy, Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { InlineSvgComponent } from '../inline-svg/inline-svg.component';
import { ButtonComponent } from '@woolworthsnz/styleguide';
import { NgIf } from '@angular/common';

const funGreen = `#007837`;

export interface ServiceBarItem {
	name: string;
	text: string;
	link: string;
	image: string;
	toolTipText: string;
}

@Component({
	selector: 'dc-service-bar-item',
	template: `
		<a
			cdxButton
			[attr.href]="link === '' ? null : link"
			fillStyle="secondaryFlat"
			startSlotActive="true"
			orientation="vertical"
			(click)="handleClick(name)"
			[title]="tooltip"
		>
			<dc-inline-svg [image]="image" [fill]="fillColor" [hover]="hover"></dc-inline-svg>
			<span>{{ text }}</span>
			<div *ngIf="badgeValue" class="service-bar-item__badge" [style.background-color]="badgeColor">
				<span>{{ badgeValue }}</span>
			</div>
		</a>
	`,
	styleUrls: ['./service-bar-item.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [ButtonComponent, InlineSvgComponent, NgIf],
})
export class ServiceBarItemComponent {
	@Input()
	name: string;

	@Input()
	text: string;

	@Input()
	image: string;

	@Input()
	fill = 'dark';

	@Input()
	hoverColor: string;

	@Input()
	link = '';

	@Input()
	tooltip = '';

	@Output()
	clickEmitter: EventEmitter<any> = new EventEmitter();

	@Input() public badgeValue?: string;
	@Input() public badgeColor = funGreen;

	private _fill: string;
	private _hovering = false;

	get fillColor(): string {
		return this._fill || this.fill;
	}

	get hover(): boolean {
		return this._hovering;
	}

	@HostListener('mouseenter')
	handleMouseEnter(): void {
		this._fill = this.hoverColor || 'green';
		this._hovering = !this._hovering;
	}

	@HostListener('mouseleave')
	handleMouseLeave(): void {
		this._fill = this.fill;
		this._hovering = !this._hovering;
	}

	handleClick = (itemName: string): void => {
		this.clickEmitter.emit(itemName);
	};
}
